import { render, staticRenderFns } from "./EmailArchive.vue?vue&type=template&id=625acbf8&scoped=true"
import script from "./EmailArchive.vue?vue&type=script&lang=js"
export * from "./EmailArchive.vue?vue&type=script&lang=js"
import style0 from "./EmailArchive.vue?vue&type=style&index=0&id=625acbf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625acbf8",
  null
  
)

export default component.exports